module.exports = __webpack_public_path__ + "img/GHS06.00b5918c.gif";